<template>
  <div
    v-if="menuItems.length"
    class="row"
  >
    <nav
      class="col on-page-breadcrumbs"
      aria-label="Brödsmulor"
    >
      <a
        v-for="(link, index) in menuItems"
        :key="link + index"
        :href="link.url"
        class="on-page-breadcrumbs__text on-page-breadcrumbs__text--link"
        v-text="link.label"
      />
      <span
        class="on-page-breadcrumbs__text"
        v-text="lastMenuItemName.label"
      />
    </nav>
  </div>
  <div
    v-else
    class="no-on-page-breadcrumbs"
  />
</template>

<script>
import baseComponentSettings from "@/vue/components/baseComponentSettings"

export default {
  mixins: [baseComponentSettings],
  data () {
    return {
      menuItems: [],
      lastMenuItemName: ''
    }
  },
  created () {
    this.menuItems = Array.from(this.data)
    if (this.menuItems.length > 0) {
      this.lastMenuItemName = this.menuItems.pop()
    }
  }
}
</script>

<style lang="scss">
.no-on-page-breadcrumbs {
  height: 3.125rem;
}

.on-page-breadcrumbs {
  .row & {
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;

    @include media-breakpoint-up(md) {
      padding-bottom: 1rem;
      padding-top: 1rem;
    }
  }

  position: relative;

  &__logo.svg-icon {
    fill: $color-red;
    height: 1rem;
    width: 1.6875rem;
    vertical-align: -0.125rem;
  }

  &__text {
    @include font(text,2, "normal");

    display: inline-block;
    position: relative;
    text-decoration: none;
    padding-right: 1.5rem;

    @include media-breakpoint-up(md) {
      padding-right: 2.5rem;
    }

    &--link {
      @include font(text,2, "bold");
    }

    &::after {
      border-right: 0.0625rem solid $color-grey-dark;
      border-top: 0.0625rem solid $color-grey-dark;
      content: "";
      display: inline-block;
      height: 0.375rem;
      margin: 0 1rem;
      position: absolute;
      right: -0.6225rem;
      top: 0.4rem;
      transform: translate(-0.3125rem, 0) rotate(45deg);
      width: 0.375rem;

      @include media-breakpoint-up(md) {
        right: -0.3125rem;
      }
    }

    &:last-child {
      padding-right: 0;

      &::after {
        content: none;
      }
    }
  }
}
</style>
